/**
 * @file Language Configuration
 * @description This file serves as the single source of truth for all supported languages in the application.
 * It is used by both the UI (to display language names) and the backend (to configure model capabilities).
 */
export const SUPPORTED_LANGUAGES = [
    {
        id: 1,
        code: 'en',
        englishName: 'English',
        chineseName: '英语',
        nativeName: 'English',
    },
    {
        id: 2,
        code: 'zh-CN',
        englishName: 'Simplified Chinese',
        chineseName: '简体中文',
        nativeName: '简体中文',
    },
    {
        id: 3,
        code: 'es',
        englishName: 'Spanish',
        chineseName: '西班牙语',
        nativeName: 'Español',
    },
    {
        id: 4,
        code: 'fr',
        englishName: 'French',
        chineseName: '法语',
        nativeName: 'Français',
    },
    {
        id: 5,
        code: 'ar',
        englishName: 'Arabic',
        chineseName: '阿拉伯语',
        nativeName: 'العربية',
    },
    {
        id: 6,
        code: 'ru',
        englishName: 'Russian',
        chineseName: '俄语',
        nativeName: 'Русский',
    },
    {
        id: 7,
        code: 'de',
        englishName: 'German',
        chineseName: '德语',
        nativeName: 'Deutsch',
    },
    {
        id: 8,
        code: 'ja',
        englishName: 'Japanese',
        chineseName: '日语',
        nativeName: '日本語',
    },
    {
        id: 9,
        code: 'pt',
        englishName: 'Portuguese',
        chineseName: '葡萄牙语',
        nativeName: 'Português',
    },
    {
        id: 10,
        code: 'ko',
        englishName: 'Korean',
        chineseName: '韩语',
        nativeName: '한국어',
    },
    {
        id: 11,
        code: 'it',
        englishName: 'Italian',
        chineseName: '意大利语',
        nativeName: 'Italiano',
    },
    {
        id: 12,
        code: 'hi',
        englishName: 'Hindi',
        chineseName: '印地语',
        nativeName: 'हिन्दी',
    },
    {
        id: 13,
        code: 'id',
        englishName: 'Indonesian',
        chineseName: '印度尼西亚语',
        nativeName: 'Bahasa Indonesia',
    },
    {
        id: 14,
        code: 'tr',
        englishName: 'Turkish',
        chineseName: '土耳其语',
        nativeName: 'Türkçe',
    },
    {
        id: 15,
        code: 'vi',
        englishName: 'Vietnamese',
        chineseName: '越南语',
        nativeName: 'Tiếng Việt',
    },
    {
        id: 16,
        code: 'fa',
        englishName: 'Persian',
        chineseName: '波斯语',
        nativeName: 'فارسی',
    },
    {
        id: 17,
        code: 'th',
        englishName: 'Thai',
        chineseName: '泰语',
        nativeName: 'ไทย',
    },
    {
        id: 18,
        code: 'bn',
        englishName: 'Bengali',
        chineseName: '孟加拉语',
        nativeName: 'বাংলা',
    },
    {
        id: 19,
        code: 'ur',
        englishName: 'Urdu',
        chineseName: '乌尔都语',
        nativeName: 'اردو',
    },
    {
        id: 20,
        code: 'pa',
        englishName: 'Punjabi',
        chineseName: '旁遮普语',
        nativeName: 'ਪੰਜਾਬੀ',
    },
    {
        id: 21,
        code: 'nl',
        englishName: 'Dutch',
        chineseName: '荷兰语',
        nativeName: 'Nederlands',
    },
    {
        id: 22,
        code: 'pl',
        englishName: 'Polish',
        chineseName: '波兰语',
        nativeName: 'Polski',
    },
    {
        id: 23,
        code: 'sv',
        englishName: 'Swedish',
        chineseName: '瑞典语',
        nativeName: 'Svenska',
    },
    {
        id: 24,
        code: 'el',
        englishName: 'Greek',
        chineseName: '希腊语',
        nativeName: 'Ελληνικά',
    },
    {
        id: 25,
        code: 'uk',
        englishName: 'Ukrainian',
        chineseName: '乌克兰语',
        nativeName: 'Українська',
    },
    {
        id: 26,
        code: 'ro',
        englishName: 'Romanian',
        chineseName: '罗马尼亚语',
        nativeName: 'Română',
    },
    {
        id: 27,
        code: 'cs',
        englishName: 'Czech',
        chineseName: '捷克语',
        nativeName: 'Čeština',
    },
    {
        id: 28,
        code: 'hu',
        englishName: 'Hungarian',
        chineseName: '匈牙利语',
        nativeName: 'Magyar',
    },
    {
        id: 29,
        code: 'fi',
        englishName: 'Finnish',
        chineseName: '芬兰语',
        nativeName: 'Suomi',
    },
    {
        id: 30,
        code: 'he',
        englishName: 'Hebrew',
        chineseName: '希伯来语',
        nativeName: 'עברית',
    },
    {
        id: 31,
        code: 'da',
        englishName: 'Danish',
        chineseName: '丹麦语',
        nativeName: 'Dansk',
    },
    {
        id: 32,
        code: 'no',
        englishName: 'Norwegian',
        chineseName: '挪威语',
        nativeName: 'Norsk',
    },
    {
        id: 33,
        code: 'bg',
        englishName: 'Bulgarian',
        chineseName: '保加利亚语',
        nativeName: 'Български',
    },
    {
        id: 34,
        code: 'hr',
        englishName: 'Croatian',
        chineseName: '克罗地亚语',
        nativeName: 'Hrvatski',
    },
    {
        id: 35,
        code: 'sr',
        englishName: 'Serbian',
        chineseName: '塞尔维亚语',
        nativeName: 'Српски',
    },
    {
        id: 36,
        code: 'sk',
        englishName: 'Slovak',
        chineseName: '斯洛伐克语',
        nativeName: 'Slovenčina',
    },
    {
        id: 37,
        code: 'sl',
        englishName: 'Slovenian',
        chineseName: '斯洛文尼亚语',
        nativeName: 'Slovenščina',
    },
    {
        id: 38,
        code: 'lt',
        englishName: 'Lithuanian',
        chineseName: '立陶宛语',
        nativeName: 'Lietuvių',
    },
    {
        id: 39,
        code: 'lv',
        englishName: 'Latvian',
        chineseName: '拉脱维亚语',
        nativeName: 'Latviešu',
    },
    {
        id: 40,
        code: 'et',
        englishName: 'Estonian',
        chineseName: '爱沙尼亚语',
        nativeName: 'Eesti',
    },
    {
        id: 41,
        code: 'ms',
        englishName: 'Malay',
        chineseName: '马来语',
        nativeName: 'Bahasa Melayu',
    },
    {
        id: 42,
        code: 'tl',
        englishName: 'Filipino',
        chineseName: '菲律宾语',
        nativeName: 'Filipino',
    },
    {
        id: 43,
        code: 'sw',
        englishName: 'Swahili',
        chineseName: '斯瓦希里语',
        nativeName: 'Kiswahili',
    },
    {
        id: 44,
        code: 'af',
        englishName: 'Afrikaans',
        chineseName: '南非荷兰语',
        nativeName: 'Afrikaans',
    },
    {
        id: 45,
        code: 'ha',
        englishName: 'Hausa',
        chineseName: '豪萨语',
        nativeName: 'Hausa',
    },
    {
        id: 46,
        code: 'yo',
        englishName: 'Yoruba',
        chineseName: '约鲁巴语',
        nativeName: 'Yorùbá',
    },
    {
        id: 47,
        code: 'ig',
        englishName: 'Igbo',
        chineseName: '伊博语',
        nativeName: 'Igbo',
    },
    {
        id: 48,
        code: 'zu',
        englishName: 'Zulu',
        chineseName: '祖鲁语',
        nativeName: 'isiZulu',
    },
    {
        id: 49,
        code: 'am',
        englishName: 'Amharic',
        chineseName: '阿姆哈拉语',
        nativeName: 'አማርኛ',
    },
    {
        id: 50,
        code: 'so',
        englishName: 'Somali',
        chineseName: '索马里语',
        nativeName: 'Soomaali',
    },
    {
        id: 51,
        code: 'ta',
        englishName: 'Tamil',
        chineseName: '泰米尔语',
        nativeName: 'தமிழ்',
    },
    {
        id: 52,
        code: 'te',
        englishName: 'Telugu',
        chineseName: '泰卢固语',
        nativeName: 'తెలుగు',
    },
    {
        id: 53,
        code: 'mr',
        englishName: 'Marathi',
        chineseName: '马拉地语',
        nativeName: 'मराठी',
    },
    {
        id: 54,
        code: 'kn',
        englishName: 'Kannada',
        chineseName: '卡纳达语',
        nativeName: 'ಕನ್ನಡ',
    },
    {
        id: 55,
        code: 'gu',
        englishName: 'Gujarati',
        chineseName: '古吉拉特语',
        nativeName: 'ગુજરાતી',
    },
    {
        id: 56,
        code: 'ml',
        englishName: 'Malayalam',
        chineseName: '马拉雅拉姆语',
        nativeName: 'മലയാളം',
    },
    {
        id: 57,
        code: 'ne',
        englishName: 'Nepali',
        chineseName: '尼泊尔语',
        nativeName: 'नेपाली',
    },
    {
        id: 58,
        code: 'or',
        englishName: 'Odia',
        chineseName: '奥里亚语',
        nativeName: 'ଓଡ଼ିଆ',
    },
    {
        id: 59,
        code: 'si',
        englishName: 'Sinhala',
        chineseName: '僧伽罗语',
        nativeName: 'සිංහල',
    },
    {
        id: 60,
        code: 'az',
        englishName: 'Azerbaijani',
        chineseName: '阿塞拜疆语',
        nativeName: 'Azərbaycan',
    },
    {
        id: 61,
        code: 'uz',
        englishName: 'Uzbek',
        chineseName: '乌兹别克语',
        nativeName: 'O‘zbek',
    },
    {
        id: 62,
        code: 'kk',
        englishName: 'Kazakh',
        chineseName: '哈萨克语',
        nativeName: 'Қазақ',
    },
    {
        id: 63,
        code: 'be',
        englishName: 'Belarusian',
        chineseName: '白俄罗斯语',
        nativeName: 'Беларуская',
    },
    {
        id: 64,
        code: 'hy',
        englishName: 'Armenian',
        chineseName: '亚美尼亚语',
        nativeName: 'Հայերեն',
    },
    {
        id: 65,
        code: 'ka',
        englishName: 'Georgian',
        chineseName: '格鲁吉亚语',
        nativeName: 'ქართული',
    },
    {
        id: 66,
        code: 'sq',
        englishName: 'Albanian',
        chineseName: '阿尔巴尼亚语',
        nativeName: 'Shqip',
    },
    {
        id: 67,
        code: 'bs',
        englishName: 'Bosnian',
        chineseName: '波斯尼亚语',
        nativeName: 'Bosanski',
    },
    {
        id: 68,
        code: 'mk',
        englishName: 'Macedonian',
        chineseName: '马其顿语',
        nativeName: 'Македонски',
    },
    {
        id: 69,
        code: 'my',
        englishName: 'Burmese',
        chineseName: '缅甸语',
        nativeName: 'မြန်မာ',
    },
    {
        id: 70,
        code: 'km',
        englishName: 'Khmer',
        chineseName: '高棉语',
        nativeName: 'ខ្មែរ',
    },
    {
        id: 71,
        code: 'lo',
        englishName: 'Lao',
        chineseName: '老挝语',
        nativeName: 'ລາວ',
    },
    {
        id: 72,
        code: 'jv',
        englishName: 'Javanese',
        chineseName: '爪哇语',
        nativeName: 'Basa Jawa',
    },
    {
        id: 73,
        code: 'mn',
        englishName: 'Mongolian',
        chineseName: '蒙古语',
        nativeName: 'Монгол',
    },
    {
        id: 74,
        code: 'tg',
        englishName: 'Tajik',
        chineseName: '塔吉克语',
        nativeName: 'Тоҷикӣ',
    },
    {
        id: 75,
        code: 'ky',
        englishName: 'Kyrgyz',
        chineseName: '吉尔吉斯语',
        nativeName: 'Кыргыз',
    },
    {
        id: 76,
        code: 'tk',
        englishName: 'Turkmen',
        chineseName: '土库曼语',
        nativeName: 'Türkmen',
    },
    {
        id: 77,
        code: 'ug',
        englishName: 'Uyghur',
        chineseName: '维吾尔语',
        nativeName: 'Uyghur',
    },
    {
        id: 78,
        code: 'is',
        englishName: 'Icelandic',
        chineseName: '冰岛语',
        nativeName: 'Íslenska',
    },
    {
        id: 79,
        code: 'ga',
        englishName: 'Irish',
        chineseName: '爱尔兰语',
        nativeName: 'Gaeilge',
    },
    {
        id: 80,
        code: 'cy',
        englishName: 'Welsh',
        chineseName: '威尔士语',
        nativeName: 'Cymraeg',
    },
    {
        id: 81,
        code: 'ca',
        englishName: 'Catalan',
        chineseName: '加泰罗尼亚语',
        nativeName: 'Català',
    },
    {
        id: 82,
        code: 'eu',
        englishName: 'Basque',
        chineseName: '巴斯克语',
        nativeName: 'Euskara',
    },
    {
        id: 83,
        code: 'gl',
        englishName: 'Galician',
        chineseName: '加利西亚语',
        nativeName: 'Galego',
    },
    {
        id: 84,
        code: 'mt',
        englishName: 'Maltese',
        chineseName: '马耳他语',
        nativeName: 'Malti',
    },
    {
        id: 85,
        code: 'om',
        englishName: 'Oromo',
        chineseName: '奥罗莫语',
        nativeName: 'Afaan Oromoo',
    },
    {
        id: 86,
        code: 'xh',
        englishName: 'Xhosa',
        chineseName: '科萨语',
        nativeName: 'isiXhosa',
    },
    {
        id: 87,
        code: 'mg',
        englishName: 'Malagasy',
        chineseName: '马达加斯加语',
        nativeName: 'Malagasy',
    },
    {
        id: 88,
        code: 'sn',
        englishName: 'Shona',
        chineseName: '绍纳语',
        nativeName: 'chiShona',
    },
    {
        id: 89,
        code: 'ps',
        englishName: 'Pashto',
        chineseName: '普什图语',
        nativeName: 'پښتو',
    },
    {
        id: 90,
        code: 'ti',
        englishName: 'Tigrinya',
        chineseName: '提格里尼亚语',
        nativeName: 'ትግርኛ',
    },
    {
        id: 91,
        code: 'sd',
        englishName: 'Sindhi',
        chineseName: '信德语',
        nativeName: 'سنڌي',
    },
    {
        id: 92,
        code: 'ht',
        englishName: 'Haitian Creole',
        chineseName: '海地克里奥尔语',
        nativeName: 'Kreyòl Ayisyen',
    },
    {
        id: 93,
        code: 'ku',
        englishName: 'Kurdish (Kurmanji)',
        chineseName: '库尔德语（库尔曼吉语）',
        nativeName: 'Kurdî (Kurmancî)',
    },
    {
        id: 94,
        code: 'ckb',
        englishName: 'Kurdish (Sorani)',
        chineseName: '库尔德语（索拉尼语）',
        nativeName: 'Kurdî (Soranî)',
    },
    {
        id: 95,
        code: 'ny',
        englishName: 'Chichewa',
        chineseName: '齐切瓦语',
        nativeName: 'Chichewa',
    },
    {
        id: 96,
        code: 'st',
        englishName: 'Sesotho',
        chineseName: '塞索托语',
        nativeName: 'Sesotho',
    },
    {
        id: 97,
        code: 'tn',
        englishName: 'Tswana',
        chineseName: '茨瓦纳语',
        nativeName: 'Setswana',
    },
    {
        id: 98,
        code: 'bo',
        englishName: 'Tibetan',
        chineseName: '藏语',
        nativeName: 'བོད་ཡིག',
    },
    {
        id: 99,
        code: 'dv',
        englishName: 'Dhivehi',
        chineseName: '迪维希语',
        nativeName: 'ދިވެހި',
    },
    {
        id: 100,
        code: 'mnw',
        englishName: 'Mon',
        chineseName: '孟语',
        nativeName: 'Mon',
    },
    {
        id: 101,
        code: 'la',
        englishName: 'Latin',
        chineseName: '拉丁语',
        nativeName: 'Latina',
    },
    {
        id: 102,
        code: 'eo',
        englishName: 'Esperanto',
        chineseName: '世界语',
        nativeName: 'Esperanto',
    },
    {
        id: 103,
        code: 'sa',
        englishName: 'Sanskrit',
        chineseName: '梵语',
        nativeName: 'संस्कृतम्',
    },
    {
        id: 104,
        code: 'zh-TW',
        englishName: 'Traditional Chinese',
        chineseName: '繁體中文',
        nativeName: '繁體中文',
    },
    {
        id: 105,
        code: 'tt',
        englishName: 'Tatar',
        chineseName: '鞑靼语',
        nativeName: 'Tatarça',
    },
    {
        id: 106,
        code: 'bho',
        englishName: 'Bhojpuri',
        chineseName: '博杰普尔语',
        nativeName: 'भोजपुरी',
    },
    {
        id: 107,
        code: 'mai',
        englishName: 'Maithili',
        chineseName: '迈蒂利语',
        nativeName: 'मैथिली',
    },
    {
        id: 108,
        code: 'ks',
        englishName: 'Kashmiri',
        chineseName: '克什米尔语',
        nativeName: 'कश्मीरी',
    },
    {
        id: 109,
        code: 'gom',
        englishName: 'Goan Konkani',
        chineseName: '果阿孔卡尼语',
        nativeName: 'गो कोंकणी',
    },
    {
        id: 110,
        code: 'sat',
        englishName: 'Santali',
        chineseName: '桑塔利语',
        nativeName: 'ᱥᱟᱱᱛᱟᱲᱤ',
    },
    {
        id: 111,
        code: 'as',
        englishName: 'Assamese',
        chineseName: '阿萨姆语',
        nativeName: 'অসমীয়া',
    },
    {
        id: 112,
        code: 'yue',
        englishName: 'Cantonese',
        chineseName: '粤语',
        nativeName: '粵語',
    },
];
//# sourceMappingURL=language.config.js.map